module.exports = __webpack_public_path__ + "09_face.957f9dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/09_face.png
// module id = q9nH
// module chunks = 0